/* eslint-disable */
// src/tables/visitStrategies/PrizeStrategy.js

import React from "react";
import BaseStrategy from "./BaseStrategy";
import { moneyFmtDynamic } from "utils/formatters";
import {
  SIMPLE_MACHINE_DATA_WIDTH,
  centeredDataBlockStyle,
  compactNumericInputStyle,
  fullWidthDataRowStyle,
} from "components/visit/individualEditorSizing";

export default class PrizeStrategy extends BaseStrategy {
  pickCalculatedNumber(m, camelKey, pascalKey) {
    if (this.isEdit && Object.prototype.hasOwnProperty.call(m || {}, camelKey)) {
      return this.pickNumber(m, camelKey);
    }
    return this.pickNumber(m, pascalKey, camelKey);
  }

  buildCells(m) {
    const key = this.computeKey(m);
    const isCollected = this.isWasCollected(m, key);
    const creditsIn = this.pickNumber(m, "actualCreditsIn", "CreditsIn");
    const creditsOut = this.pickNumber(m, "actualCreditsOut", "CreditsOut");
    const pricePerPrize = this.pickNumber(m, "netCreditsOut", "NetCreditsOut");
    const moneyIn = this.pickCalculatedNumber(m, "moneyIn", "MoneyIn");
    const moneyOut = this.pickCalculatedNumber(m, "moneyOut", "MoneyOut");
    const moneyCollected = this.pickCalculatedNumber(m, "moneyCollected", "MoneyCollected");

    // Fórmula como "precio ficha" (Peluchera)
    const fv = this.getFormulaValue(m);
    const formulaText =
      fv != null
        ? `${this.individualEditorLayout || this.collectionDetailPresentation ? "Ficha" : "Precio ficha"}: ${moneyFmtDynamic.format(fv)}`
        : null;
    const machineCell = this.MachineCell({ m, hasRent: false, formulaText });
    const noteCell = this.NoteCell({ keyId: key, m });

    if (!isCollected && this.isRead) {
      return {
        Machine: machineCell,
        Note: noteCell,
      };
    }

    let inCell = null, outCell = null, totalCell = null;

    if (this.isRead) {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          <div>Fichas: {this.nf.format(creditsIn || 0)}</div>
          <div>Dinero: <strong>{this.moneyFmt.format(moneyIn || 0)}</strong></div>
        </div>
      );
      outCell = (
        <div>
          <div>Cant. premios: {this.nf.format(creditsOut || 0)}</div>
          <div>Precio c/u: {pricePerPrize != null ? this.moneyFmt.format(pricePerPrize) : "—"}</div>
          <div>Costo premios: <strong>{this.moneyFmt.format(moneyOut || 0)}</strong></div>
        </div>
      );
      totalCell = (
        <div>
          Dinero:{" "}
           <strong
            style={this.negStyle(moneyCollected || 0)}
          >
            {this.moneyFmt.format(moneyCollected || 0)}
          </strong>
          </div>
      );
    } else {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          {this.NumericInput({
            id: `creditsIn-${key}`,
            name: `creditsIn-${key}`,
            label: "Fichas:",
            keyId: key,
            field: "CreditsIn",
            inputStyleOverride: this.individualEditorLayout ? compactNumericInputStyle : null,
          })}
          <div style={this.individualEditorLayout ? fullWidthDataRowStyle(this.rowLine) : this.rowLine}>
            <span>Dinero:</span>
            <span style={{ fontWeight: 700 }}>
              {moneyIn != null
                ? this.moneyFmt.format(moneyIn)
                : "Pendiente"}
            </span>
          </div>
        </div>
      );

      outCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          {this.NumericInput({
            id: `creditsOut-${key}`,
            name: `creditsOut-${key}`,
            label: "Cant. premios:",
            keyId: key,
            field: "CreditsOut",
            inputStyleOverride: this.individualEditorLayout ? compactNumericInputStyle : null,
          })}
          {this.NumericInput({
            id: `netCreditsOut-${key}`,
            name: `netCreditsOut-${key}`,
            label: "Precio c/u:",
            keyId: key,
            field: "netCreditsOut",
            inputStyleOverride: this.individualEditorLayout ? compactNumericInputStyle : null,
          })}
          <div style={this.individualEditorLayout ? fullWidthDataRowStyle(this.rowLine) : this.rowLine}>
            <span>Costo premios:</span>
            <span style={{ fontWeight: 700 }}>
              {moneyOut != null
                ? this.moneyFmt.format(moneyOut)
                : "Pendiente"}
            </span>
          </div>
        </div>
      );

      totalCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          <div style={this.individualEditorLayout ? fullWidthDataRowStyle(this.rowLine) : this.rowLine}>
            <span>Dinero:</span>
             <span
              style={
                moneyCollected != null
                  ? { ...this.negStyle(moneyCollected), fontWeight: 700 }
                  : { fontWeight: 700 }
              }
            >
              {moneyCollected != null
                ? this.moneyFmt.format(moneyCollected)
                : "Pendiente"}
            </span>
          </div>
        </div>
      );
    }

    return {
      Machine: machineCell,
      In: inCell,
      Out: outCell || undefined,
      Total: totalCell || undefined,
      Note: noteCell,
    };
  }
}
